import { Activity, TrendingUp, Sparkles } from 'lucide-react';

export default function AIJournalPromo() {
  return (
    <div className="bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 rounded-2xl shadow-2xl p-8 mb-12" data-testid="ai-journal-promo">
      <div className="text-center mb-6">
        <div className="flex justify-center mb-4">
          <div className="p-4 bg-purple-100 rounded-full">
            <Sparkles className="w-12 h-12 text-purple-600" />
          </div>
        </div>
        <h2 className="text-3xl font-bold text-purple-900 mb-2">
          AI-Powered Performance Journal Insights
        </h2>
        <p className="text-lg text-purple-800 max-w-3xl mx-auto">
          Get personalized analysis of your performance patterns, correlations, and evidence-based recommendations from your journal entries
        </p>
      </div>
      
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow">
          <Activity className="w-10 h-10 text-blue-600 mx-auto mb-3" />
          <h3 className="font-semibold text-gray-900 mb-2">Physical Trends</h3>
          <p className="text-sm text-gray-600">Sleep quality, energy levels, and nutrition patterns analyzed</p>
        </div>
        <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow">
          <Sparkles className="w-10 h-10 text-purple-600 mx-auto mb-3" />
          <h3 className="font-semibold text-gray-900 mb-2">Mental Insights</h3>
          <p className="text-sm text-gray-600">Mood, confidence, stress, and anxiety patterns identified</p>
        </div>
        <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow">
          <TrendingUp className="w-10 h-10 text-green-600 mx-auto mb-3" />
          <h3 className="font-semibold text-gray-900 mb-2">Performance Patterns</h3>
          <p className="text-sm text-gray-600">Goals, highlights, and improvement areas tracked</p>
        </div>
      </div>

      <div className="text-center">
        <button 
          onClick={() => window.location.href = '/trends'}
          className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-lg hover:shadow-xl transition-all inline-flex items-center gap-2"
          data-testid="view-ai-insights-btn"
        >
          <Sparkles className="w-5 h-5" />
          View AI-Generated Insights
          <TrendingUp className="w-5 h-5" />
        </button>
        <p className="text-sm text-gray-600 mt-4">
          Based on your Performance Journal entries • Updated in real-time
        </p>
      </div>
    </div>
  );
}
